import { render, staticRenderFns } from "./EmailRecoverySent.vue?vue&type=template&id=27997a9c&"
import script from "./EmailRecoverySent.vue?vue&type=script&lang=ts&"
export * from "./EmailRecoverySent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports